import React from "react";
// @ts-ignore antd v4 doesn't have theme
import { ConfigProvider, theme as antdTheme } from "antd";
import { CssVarsProvider } from "./CssVarsProvider";
import { buildAlgorithms, mergeThemes } from "../../utils/theming";
var Provider = function Provider(_ref) {
  var _config$settings$them, _config$settings$loca, _antdTheme$useToken, _config$settings$desi;
  var config = _ref.config,
    children = _ref.children;
  var themeMode = config.settings.themeMode;
  var darkMode = themeMode === "dark";
  var compactMode = !!config.settings.compactMode;
  var themeConfig = (_config$settings$them = config.settings.theme) === null || _config$settings$them === void 0 ? void 0 : _config$settings$them.antd;
  var localeConfig = (_config$settings$loca = config.settings.locale) === null || _config$settings$loca === void 0 ? void 0 : _config$settings$loca.antd;
  var canCreateAlgorithms = darkMode || compactMode;
  var canCreateTheme = !!themeConfig || localeConfig || canCreateAlgorithms;
  var _ref2 = (_antdTheme$useToken = antdTheme === null || antdTheme === void 0 ? void 0 : antdTheme.useToken()) !== null && _antdTheme$useToken !== void 0 ? _antdTheme$useToken : {},
    existingOuterToken = _ref2.token,
    existingTheme = _ref2.theme; // antd v4 doesn't have theme
  var existingToken = (_config$settings$desi = config.settings.designSettings) !== null && _config$settings$desi !== void 0 && _config$settings$desi.canInheritThemeFromOuterProvider ? existingOuterToken : undefined;
  var _React$useMemo = React.useMemo(function () {
      return buildAlgorithms(darkMode, compactMode);
    }, [darkMode, compactMode]),
    algorithms = _React$useMemo.algorithms;
  var customThemeConfig = React.useMemo(function () {
    return canCreateTheme ? mergeThemes(themeMode, existingToken, themeConfig, algorithms) : undefined;
  }, [algorithms, themeConfig, existingTheme === null || existingTheme === void 0 ? void 0 : existingTheme.id, themeMode, canCreateTheme]);
  var withCssVarsProvider = /*#__PURE__*/React.createElement(CssVarsProvider, {
    config: config
  }, children);

  // https://ant.design/components/config-provider
  var withTheme = canCreateTheme ?
  /*#__PURE__*/
  // @ts-ignore error TS2786: 'ConfigProvider' cannot be used as a JSX component. Its return type 'ReactNode | Promise<ReactNode>' is not a valid JSX element.
  React.createElement(ConfigProvider, {
    locale: localeConfig
    // @ts-ignore antd v4 doesn't have theme
    ,
    theme: customThemeConfig
  }, withCssVarsProvider) : withCssVarsProvider;
  return withTheme;
};
export { Provider };